// @flow
import { connect } from "react-redux";
import PlotMapDialog from "./view";
import Dialog from "../dialog";
import { hideDialog, fetchUserInfo } from "../state/context/actions";
import { isDialogOpen } from "../state/context/reducer";
import { fetchStops } from "../state/map/actions";

export default connect(
    state => ({
        open: isDialogOpen(state, "PlotMap"),
        Dialog
    }),
    dispatch => ({
        onHide: () => dispatch(hideDialog("PlotMap")),
        onFetchStops: () => dispatch(fetchStops()),
        onFetchUserInfo: () => dispatch(fetchUserInfo())
    })
)(PlotMapDialog);



// WEBPACK FOOTER //
// ./src/plot-map-dialog/index.js